import CONSTANTS from '../constants'
import { postRequest, downloadFile } from '../../services'
import { APICONFIG } from '../apiConfig'
import { addEventLog } from '../actions/eventLogActions'

// Calls the API to get Payment Initials
export const getPaymentInitials = (data) => (dispatch) => {
	dispatch(addEventLog(data, CONSTANTS.PAYMENT_INITIAL_REQUEST))
	dispatch({ type: CONSTANTS.PAYMENT_INITIAL_REQUEST })
	return postRequest(APICONFIG.getPaymentInitialUrl, data).then((res) => {
		let resObject = { ...data, ...res }
		dispatch(addEventLog(resObject, CONSTANTS.PAYMENT_INITIAL_SUCCESS))
		dispatch({ type: CONSTANTS.PAYMENT_INITIAL_SUCCESS, data: res })
		return res
	}).catch((err) => {
		let resObject = { ...data, ...err }
		dispatch(addEventLog(resObject, CONSTANTS.PAYMENT_INITIAL_FAILURE))
		dispatch({ type: CONSTANTS.PAYMENT_INITIAL_FAILURE, errorMessage:err })
		return err
	})
}

// Store the User Details for Payment
export const storeUserDetails = (data) => (dispatch) => {
	dispatch({ type: CONSTANTS.STORE_USER_DETAILS_SUCCESS, data })
}

export const getAfterPaymentSuccess = (postData) => (dispatch) => {
	dispatch(addEventLog(postData, CONSTANTS.AFTER_PAYMENT_REQUEST))
	dispatch({ type: CONSTANTS.AFTER_PAYMENT_REQUEST })
	return postRequest(APICONFIG.getAfterPaymentSuccess, postData).then((res) => {
		let resObject = { ...postData, ...res }
		dispatch(addEventLog(resObject, CONSTANTS.AFTER_PAYMENT_SUCCESS))
		dispatch({ type: CONSTANTS.AFTER_PAYMENT_SUCCESS, data: res })
		return res
	}).catch((err) => {
		let resObject = { ...postData, ...err }
		dispatch(addEventLog(resObject, CONSTANTS.AFTER_PAYMENT_FAILURE))
		dispatch({ type: CONSTANTS.AFTER_PAYMENT_FAILURE })
	})
}

export const downloadQrcodeRequest = (postData, pdfName, setPromoLoader) => (dispatch) => {
	dispatch({ type: CONSTANTS.QRCODE_REQUEST })
	let endpoint = `${APICONFIG.downloadQrcodeRequestUrl}/${postData}`
	return downloadFile(endpoint, `${pdfName}.pdf`,setPromoLoader)
}	

//CHECK PROMOCODE IS VALID OR NOT
export const getPromoCodeDetails = (postData) => (dispatch) => {
	dispatch(addEventLog(postData, CONSTANTS.GET_PROMOCODE_REQUEST))
	dispatch({ type: CONSTANTS.GET_PROMOCODE_REQUEST })
	return postRequest(APICONFIG.getPromoCodeUrl, postData).then((res) => {
		let resObject = { ...postData, ...res }
		dispatch(addEventLog(resObject, CONSTANTS.GET_PROMOCODE_SUCCESS))
		dispatch({ type: CONSTANTS.GET_PROMOCODE_SUCCESS, data: res })
		return res
	}).catch((err) => {
		let resObject = { ...postData, ...err }
		dispatch(addEventLog(resObject, CONSTANTS.GET_PROMOCODE_FAILURE))
		dispatch({ type: CONSTANTS.GET_PROMOCODE_FAILURE })
		return err
	})
}

//UPDATE PROMOCODE USAGE DETAILS
export const updatePromoCodeUsageDetails = (postData) => (dispatch) => {
	dispatch(addEventLog(postData, CONSTANTS.GET_PROMOCODE_USAGE_REQUEST))
	dispatch({ type: CONSTANTS.GET_PROMOCODE_USAGE_REQUEST })
	return postRequest(APICONFIG.getPromoCodeUsage, postData).then((res) => {
		let resObject = { ...postData, ...res }
		dispatch(addEventLog(resObject, CONSTANTS.GET_PROMOCODE_USAGE_SUCCESS))
		dispatch({ type: CONSTANTS.GET_PROMOCODE_USAGE_SUCCESS, data: res })
		return res
	}).catch((err) => {
		let resObject = { ...postData, ...err }
		dispatch(addEventLog(resObject, CONSTANTS.GET_PROMOCODE_USAGE_FAILURE))
		dispatch({ type: CONSTANTS.GET_PROMOCODE_USAGE_FAILURE })
	})
}

// Calls the API to booking before payment
export const saveBookingBeforePayment = (postData) => (dispatch) => {
	dispatch(addEventLog(postData, CONSTANTS.BEFORE_PAYMENT_INITIAL_REQUEST))
	dispatch({ type: CONSTANTS.BEFORE_PAYMENT_INITIAL_REQUEST })
	return postRequest(APICONFIG.saveBookingBeforePaymentUrl, postData).then((res) => {
		let resObject = { ...postData, ...res }
		dispatch(addEventLog(resObject, CONSTANTS.BEFORE_PAYMENT_INITIAL_SUCCESS))
		dispatch({ type: CONSTANTS.BEFORE_PAYMENT_INITIAL_SUCCESS, data: res })
		return res
	}).catch((err) => {
		let resObject = { ...postData, ...err }
		dispatch(addEventLog(resObject, CONSTANTS.BEFORE_PAYMENT_INITIAL_FAILURE))
		dispatch({ type: CONSTANTS.BEFORE_PAYMENT_INITIAL_FAILURE })
	})
}

// Calls the API to booking before payment
export const saveBookingAfterPayment = (postData) => (dispatch) => {
	dispatch(addEventLog(postData, CONSTANTS.AFTER_PAYMENT_INITIAL_REQUEST))
	dispatch({ type: CONSTANTS.AFTER_PAYMENT_INITIAL_REQUEST })
	return postRequest(APICONFIG.saveBookingafterPaymentUrl, postData).then((res) => {
		let resObject = { ...postData, ...res }
		dispatch(addEventLog(resObject, CONSTANTS.AFTER_PAYMENT_INITIAL_SUCCESS))
		dispatch({ type: CONSTANTS.AFTER_PAYMENT_INITIAL_SUCCESS, data: res })
		return res
	}).catch((err) => {
		let resObject = { ...postData, ...err }
		dispatch(addEventLog(resObject, CONSTANTS.AFTER_PAYMENT_INITIAL_FAILURE))
		dispatch({ type: CONSTANTS.AFTER_PAYMENT_INITIAL_FAILURE })
		return err
	})
}